<template>
  <div>
    <b-container>

      <b-row>
        <b-col>
          <div class="mt-4 d-flex justify-content-between">
            <back-arrow title="Ajouter un état quotidien"/>
          </div>
        </b-col>
      </b-row>

      <b-form ref="form" @submit.stop.prevent>

        <b-row class="mt-4 align-items-stretch">

          <b-col lg="4">
            <daily-status-card-date
              :formDate="formDate"
              @didChangeForDate="formDate.forDate.value = $event"
              @didChangeIsMorning="formDate.isMorning.value = $event"
            ></daily-status-card-date>
          </b-col>

          <b-col lg="8" class="mt-4 mt-lg-0">
            <daily-status-card-health
              :formHealth="formHealth"
              @didChangeStatus="formHealth.healthState.value = $event"
              @didChangeTemperature="formHealth.temperature.value = $event"
              @didChangeHydration="formHealth.hydration.value = $event"
              @didChangeHealthStateInformation="formHealth.healthStateInformation.value = $event"
              @didChangeWeight="formHealth.weight.value = $event"
            ></daily-status-card-health>
          </b-col>

        </b-row>

        <b-row class="mt-4">
          <b-col lg="12">
            <daily-status-card-transit
              :formTransit="formTransit"
              @didChangeSelectedTransits="formTransit.selectedTransits.value = $event"
              @didChangeTransitInformation="formTransit.transitInformation.value = $event"
            ></daily-status-card-transit>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col lg="12">
            <daily-status-card-food
              v-if="hospitalization"
              :animal="hospitalization.animal"
              :formFood="formFood"
              @didChangeSelectedFoods="didChangeSelectedFoods"
              @didChangeFoodInformation="formFood.foodInformation.value = $event"
              @didChangeTubeFeeding="formFood.tubeFeeding.value = $event"
              @didChangeTubeFeedingQuantity="formFood.tubeFeedingQuantity.value = $event"
            ></daily-status-card-food>
          </b-col>
        </b-row>

        <b-row class="mt-4">
          <b-col lg="12">
            <daily-status-card-daily-goal
              :formDailyGoal="formDailyGoal"
              @didChangeDailyGoalInformation="formDailyGoal.dailyGoalInformation.value = $event"
            ></daily-status-card-daily-goal>
          </b-col>
        </b-row>

        <b-row class="mt-4 mb-4">
          <b-col md="6">
            <b-button type="submit" variant="outline-primary" class="btn-block h-100" @click="didClickOnSaveBtn" :disabled="sendButtonDisabled">Enregistrer</b-button>
          </b-col>
          <b-col md="6" class="mt-4 mt-md-0">
            <b-button type="submit" variant="primary" class="btn-block h-100" @click="didClickOnPublishBtn" :disabled="sendButtonDisabled">Publier l'état quotidien</b-button>
          </b-col>
        </b-row>

      </b-form>

    </b-container>
  </div>
</template>

<script>

import api from '../../services/api';
import BackArrow from "../../components/BackArrow";
import DailyStatusCardDate from "./cards/DailyStatusCardDate";
import DailyStatusCardHealth from "./cards/DailyStatusCardHealth";
import DailyStatusCardTransit from "./cards/DailyStatusCardTransit";
import DailyStatusCardFood from "./cards/DailyStatusCardFood";
import DailyStatusCardDailyGoal from "./cards/DailyStatusCardDailyGoal";

export default {

  name: 'DailyStatusCreate',

  components: {
    BackArrow,
    DailyStatusCardDate,
    DailyStatusCardHealth,
    DailyStatusCardTransit,
    DailyStatusCardFood,
    DailyStatusCardDailyGoal
  },

  data() {
    return {

      sendButtonDisabled: false,

      hospitalizationId: this.$route.params.hospitalizationId,
      hospitalization: null,

      // CARD DATE
      formDate: {
        forDate: {
          state: null,
          invalidFeedback: null,
          value: new Date().getTime()
        },
        isMorning: {
          state: null,
          invalidFeedback: null,
          value: true
        },
      },

      // CARD HEALTH
      formHealth: {
        temperature: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        healthState: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        hydration: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        healthStateInformation: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        weight: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },

      // CARD TRANSIT
      formTransit: {
        selectedTransits: {
          state: null,
          invalidFeedback: null,
          value: []
        },
        transitInformation: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },

      // CARD FOOD
      formFood: {
        selectedFoods: {
          state: null,
          invalidFeedback: null,
          value: []
        },
        foodInformation: {
          state: null,
          invalidFeedback: null,
          value: null
        },
        tubeFeeding: {
          state: null,
          invalidFeedback: null,
          value: false
        },
        tubeFeedingQuantity: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      },

      //CARD DAILY GOAL
      formDailyGoal: {
        dailyGoalInformation: {
          state: null,
          invalidFeedback: null,
          value: null
        }
      }
    }
  },

  created() {
    this.fetchHospitalization()
  },

  methods: {

    fetchHospitalization() {
      api
        .get(`/hospitalization/${this.hospitalizationId}`)
        .then(response => {
          this.hospitalization = response.data
        })
    },

    didChangeSelectedFoods(selectedFoods) {
      this.formFood.selectedFoods.value = selectedFoods
    },

    didClickOnSaveBtn() {
      this.onSubmit(false)
    },

    didClickOnPublishBtn() {
      this.onSubmit(true)
    },

    onSubmit(shouldPublish) {

      if (!this.$refs.form.checkValidity()) {
        return
      }
      this.sendButtonDisabled = true

      let data = new FormData()

      data.append('hospitalizationId', this.hospitalizationId)
      data.append('shouldPublish', shouldPublish)

      data.append('forDate', this.formDate.forDate.value)
      data.append('isMorning', this.formDate.isMorning.value)

      data.append('healthStateId', this.formHealth.healthState.value)
      if(this.formHealth.temperature.value){
        data.append('temperature', this.formHealth.temperature.value)
      }
      if(this.formHealth.hydration.value && this.formHealth.hydration.value.trim() !== ""){
        data.append('hydration', this.formHealth.hydration.value)
      }
      if (this.formHealth.healthStateInformation.value && this.formHealth.healthStateInformation.value.trim() !== "") {
        data.append('healthStateInformation', this.formHealth.healthStateInformation.value)
      }
      if(this.formHealth.weight.value && this.formHealth.weight.value.trim() !== "") {
        data.append('weight', this.formHealth.weight.value)
      }

      data.append('selectedTransits', JSON.stringify(this.formTransit.selectedTransits.value))
      if (this.formTransit.transitInformation.value && this.formTransit.transitInformation.value.trim() !== "") {
        data.append('transitInformation', this.formTransit.transitInformation.value)
      }

      const selectedFoodsFormatted = this.formFood.selectedFoods.value.map(foodRow => {
        if (foodRow.isSelected) {
          return {
            foodId: foodRow.foodId,
            eatenPercentage: foodRow.eatenPercentage.value
          }
        }
      })
      data.append('selectedFoods', JSON.stringify(selectedFoodsFormatted))
      data.append('tubeFeeding', this.formFood.tubeFeeding.value)
      if(this.formFood.tubeFeedingQuantity.value && this.formFood.tubeFeedingQuantity.value.trim() !== ""){
        data.append('tubeFeedingQuantity', this.formFood.tubeFeedingQuantity.value)
      }
      if (this.formFood.foodInformation.value && this.formFood.foodInformation.value.trim() !== "") {
        data.append('foodInformation', this.formFood.foodInformation.value)
      }

      if(this.formDailyGoal.dailyGoalInformation.value && this.formDailyGoal.dailyGoalInformation.value.trim() !== ""){
        data.append('dailyGoalInformation', this.formDailyGoal.dailyGoalInformation.value)
      }

      api({
        method: 'POST',
        url: 'dailyStatus',
        data: data
      })
        .then((response) => {
          this.sendButtonDisabled = false
          this.$router.push({
            name: 'HospitalizationShow',
            params: {
              hospitalizationId: this.hospitalizationId
            }
          }, () => {
            this.$nextTick(() => {
              this.successToast()
            })
          })
        })
        .catch((error) => {
          this.sendButtonDisabled = false
          if (error.response.status === 418) {
            const invalidForm = error.response.data.invalidForm
            const invalidField = error.response.data.invalidField
            this[invalidForm][invalidField]["state"] = false
            this[invalidForm][invalidField]["invalidFeedback"] = error.response.data.message
          }
        });
    },

    successToast() {
      this.$bvToast.toast(`État quotidien enregistré`, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dailyStatus/DailyStatusCreate.vue